/** Display-only: "12345" / 12345 / { $numberDecimal: "12345" } -> "12,345"; blank or non-numeric -> "". */
export const formatNumber = (value: any): string => {
  const raw = value != null && typeof value === "object" ? value.$numberDecimal : value;
  if (raw == null || (typeof raw === "string" && raw.trim() === "")) return "";
  const n = Number(raw);
  return Number.isFinite(n) ? n.toLocaleString("en-US") : "";
};
